import sendPaymentReminder from './send-payment-reminder.js';

export default {
  sendPaymentReminder,
};
